export default __webpack_public_path__ + "b8261ddf4f58ad2d4dc31c29223ca7c3.svg";